import withAemIntegration from "../../../withAemIntegration";
import { useEffect } from 'react'
import env from "@lexus.com/ui/dist/utilities/env";


const ComponentEditConfig = {
    emptyLabel: "Logout",
    isEmpty: function (props) {
        return !props || !props.title || props.title.trim().length < 1;
    },
};

const Logout = (props) => {
    useEffect(() => {
        if (window?.pkce) {
            window.pkce?.signOut(`https://${env('REACT_APP_FORGEROCK_URL')}/logout?post_logout_redirect_uri=${document.referrer}`, '.lexus.com', env('NODE_ENV') !== 'production' ? 'dev' : 'prod', false, `${env('REACT_APP_SALESFORCE_SUPPORT_URL')}/secur/logout.jsp`)
        }
    }, [window?.pkce])
    return <div></div>;
};

export default withAemIntegration("lexus/components/login/logout")(Logout, ComponentEditConfig);